module.exports = __webpack_public_path__ + "img/car-3.9d1f7feb.svg";